import { Link } from "react-router-dom";
import './erro.css';

function Erro() {
  return (
    <div className='erro-container'>
      <h1>Opss... Página não encontrada!</h1>
        <Link to="/">Veja todos os filmes!</Link>
    </div>
  );
} 

export default Erro;